import React, { useContext } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { LangContext } from "../../LanguageProvider";

// id = отдельная ссылка на документ: /emcourse/<id>
const emcourseData = [
  {
    id: "metod-plan",
    title_ru: "Учебно-методический план работы на 2026-2027 учебный год",
    title_kz: "2026-2027 оқу жылына арналған оқу-әдістемелік жұмыс жоспары",
    pdf_path: "/pdf/metod_plan_2026_2027.pdf",
  },
  {
    id: "ped-sovet",
    title_ru: "План работы педагогического совета на 2026-2027 учебный год",
    title_kz: "2026-2027 оқу жылына арналған педагогтік кеңестің жұмыс жоспары",
    pdf_path: "/pdf/ped_sovet_2026_2027.pdf",
  },
];

export default function Emcourse() {
  const { lang } = useContext(LangContext);
  const { docId } = useParams();
  const navigate = useNavigate();
  const selectedPdf =
    emcourseData.find(item => item.id === docId) || emcourseData[0];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
        gap: 2,
        padding: 2,
        marginTop: "100px",
        marginBottom: "100px",
        height: "800px",
      }}>
      {/* Sidebar - PDF List */}
      <Paper
        elevation={3}
        sx={{
          width: { xs: "100%", md: "300px" },
          flexShrink: 0,
          overflowY: "auto",
        }}>
        <List component="nav">
          {emcourseData.map(item => (
            <ListItemButton
              key={item.id}
              selected={selectedPdf.id === item.id}
              onClick={() => navigate(`/emcourse/${item.id}`)}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "primary.light",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                },
              }}>
              <ListItemText
                primary={lang === "ru" ? item.title_ru : item.title_kz}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>

      {/* Main Content - PDF Viewer */}
      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          overflow: "hidden",
        }}>
        <iframe
          src={selectedPdf.pdf_path}
          title={lang === "ru" ? selectedPdf.title_ru : selectedPdf.title_kz}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>
    </Box>
  );
}
